import styled from '@emotion/styled';
import { day as EDSColors } from '@eventbrite/eds-settings';

export const FaqWrapper = styled.div`
    background: white;
    padding: 10px 32px 32px 32px;
`;
FaqWrapper.displayName = 'FaqWrapper';

export const HeaderContent = styled.div`
    margin-left: -16px;
    margin-right: -16px;
`;
HeaderContent.displayName = 'HeaderContent';

export const FaqContent = styled.p`
    background-color: ${EDSColors['ui-100']};
    border-radius: 8px;
    font-size: 14px;
    line-height: 20px;
    padding: 16px;
`;
FaqContent.displayName = 'FaqContent';
